import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

export const supportLetterConfig: PageConfig[] = [
  {
    name: "supportLetter",
    title: "Support Letter - Reta Tautoko",
    questions: [
      {
        type: "file",
        name: "supportLetter",
        title:
          "If possible, please provide a Letter of Support for your iniatiative",
        storeDataAsText: false,
        allowMultiple: false,
        maxSize: 10485760,
        waitForUpload: true,
      },
    ],
  },
];
